export default __webpack_public_path__ + "static/media/Minicard_Ah.fb0365d6.svg";